import { BaseElement } from "../Components/Elements/Graphics/BaseElement";

export interface IAnimationFrame {
    frame_uid: string;
    frame_draw(): void;
}

export function EventEmmiterClass() {
    return class EventEmmiterDescendant extends PIXI.utils.EventEmitter {};
}

export function BaseElementClass() {
    return class BaseElementDescendant extends BaseElement {};
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/AnimationFrame/Types.ts
 **/